import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Contratante, Conductor, TelefonosContratante } from '../modelos/data-emision.model';
import { ValidaRFC } from 'src/app/utilities/validaRFC';
import { RequestServices } from '../services/request.service';
import { Configuration, Encrypted } from '../Constants/configuration';
import { StorageService } from '../services/storage.service';
import { Prospecto } from '../modelos/prospecto.model';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { LogConsumoFunciones } from '../utilities/logConsumo';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CotizacionAyudaComponent } from '../cotizacion/ayuda/cotizacion-ayuda.component';
import { MatDialog } from '@angular/material/dialog';
import { StyleCocheSeguro } from '../modelos/styleCocheseguro.model';
import { NotificacionComponent } from '../tools/notificacion/notificacion.component';
import { InicioComponent } from '../inicio/inicio.component';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
declare var gtag;

@Component({
  selector: 'datos-emision',
  templateUrl: './datos-emision.component.html',
  styleUrls: ['./datos-emision.component.css']
})
export class DatosEmisionComponent {
  public const: Configuration = new Configuration();
  public styleCocheSeguro:StyleCocheSeguro = new StyleCocheSeguro();
  value: string = "";
  contratante: Contratante = new Contratante();
  conductor: Conductor = new Conductor();
  dataProspecto: Prospecto = new Prospecto();
  correo: string = "";
  dateContratante: any = {};
  fec_nac: string = "";
  arrayColonia: any = [{ c1: "", c2: "Colonia" }];
  arrayCiudad: any = [{ c1: "", c2: "Ciudad" }];
  telefono: string = "";
  celular: string = "";
  aseguradoraId = 0;
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestServices, this.storageService, this.router);
  telefonos: Array<TelefonosContratante> = [
    {
      cve_lada: '',
      cve_lada_nac: '',
      num_tel: '',
      tipo: 2
    },
    {
      cve_lada: '',
      cve_lada_nac: '',
      num_tel: '',
      tipo: 1
    }
  ];
  dataDireccion:any = {};
  switchLoader:boolean = false;

  constructor(private router: Router, private requestServices: RequestServices, private storageService: StorageService,
    private snackBar: MatSnackBar, private modal: MatDialog) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
  }

  ngOnInit(): void {
    gtag({'event':'formStep2View'});
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      this.updatelogConsumo();
    }
    if (cocheSeguro?.contratante) {
      this.contratante = cocheSeguro.contratante;
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
    } else {
      this.contratante.sexo = (cocheSeguro.sexo ? 'M' : 'F');
      this.dataProspecto = cocheSeguro.prospecto;
      this.correo = this.dataProspecto.correo;
      this.contratante.nombres = this.dataProspecto.nombre;
      this.contratante.direccion.cp = this.dataProspecto.cp;
    }
    this.aseguradoraId = cocheSeguro ?.cia
    this.celular = cocheSeguro ?.celular;
    this.telefono = cocheSeguro ?.telefono;
    if(this.aseguradoraId == 31){
      this.consultarDireccionAfirme360();
    }else{
      this.getCodigoPostal();
    }
    window.scrollTo(0, 0);
  }

  consultarDireccionAfirme360(){
    this.switchLoader = true;
    this.requestServices.obtenerToken().subscribe((result: any) => {
      if (result.ok) {
        this.storageService.setItem("bearerTkn", result.result);
        try {
          this.requestServices.getRequest({projectName: new Configuration().URLQUATTROAUTO, apiName: 'direccion', params: { neg_id: this.storageService.getItem('negId'), cp: this.contratante.direccion.cp }, bearer: true }).subscribe (
            result => {
              this.switchLoader = false;
              if(result.error){
                console.error("error => ", result.error);
              }else{
                  this.dataDireccion = result?.result?.data;
                  this.getCodigoPostal();
              }
            }
          )
        }catch(error){
          this.switchLoader = false;
          console.error("error: ", error);
        }
      } else {
        this.switchLoader = false;
      }
    });
  }

  generaRFC() {
    try {
      if (this.isValidDate(parseInt(this.contratante.fec_nac.split("/")[2], 10), parseInt(this.contratante.fec_nac.split("/")[1], 10), parseInt(this.contratante.fec_nac.split("/")[0], 10))) {
        this.fec_nac = this.contratante.fec_nac.split("/")[2] + '-' + this.contratante.fec_nac.split("/")[1] + '-' + this.contratante.fec_nac.split("/")[0];
        let rfcPaso = new ValidaRFC(this.snackBar).calcularRFC(this.contratante.ap_pat, this.contratante.ap_mat, this.contratante.nombres, this.fec_nac);
        this.contratante.rfc = rfcPaso;
        let edadNueva: number = this.CalculateAge(this.fec_nac);
        let cocheSeguro: CocheSeguro = new CocheSeguro();
        if (this.storageService.ifExist("cocheSeguro")) {
          cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
          if (cocheSeguro.cotizacionZurich.contact_birth_date){
            let edadCotizacion: number = this.CalculateAge(cocheSeguro.cotizacionZurich.contact_birth_date);
            if (edadNueva !== edadCotizacion) {
              this.avisoCambioCotizacion();
            }
          }
        }
        
      } else {
        this.contratante.fec_nac = "";
        this.fec_nac = "";
        this.contratante.rfc = "";
        this.snackBar.open("¡La fecha de nacimiento es incorrecta!", "favor de utlizar el formato (dd/mm/aaaa)", { duration: this.const.SNACK_BARTIME });
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  CalculateAge(fecNac: string): number {
    if (fecNac.split('/').length >= 2) {
      const anio: number = parseInt(fecNac.split('/')[2]);
      const mes: number = parseInt(fecNac.split('/')[1]);
      const dia: number = parseInt(fecNac.split('/')[0]);
      const today: Date = new Date();
      const birthDate: Date = new Date(anio, mes, dia);
      let age: number = today.getFullYear() - birthDate.getFullYear();
      const month: number = (today.getMonth() + 1) - birthDate.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    } else {
      return 18;
    }
  }

  isValidDate(year: number, month: number, day: number): boolean {
    let isValidDate: boolean = false;
    try {
      let anos = new Date().getFullYear() - year;
      if ((year.toString().length == 4 && anos > 15 && anos < 99) && (month.toString().length > 0 && month.toString().length < 3 && month < 13) && (day.toString().length > 0 && day.toString().length < 3 && day < 32)) {
        isValidDate = (new Date(year, (month - 1), day) instanceof Date);
      } else {
        console.log("formato de fecha incorrecta");
      }
    } catch (error) {
      console.error("isValidDate", error);
      isValidDate = false;
    }
    return isValidDate;
  }

  getCodigoPostal() {
    if (this.contratante.direccion.cp.length > 4) {
      const dataPrimero = [{ f1: this.contratante.direccion.cp }];
      let cocheSeguro: CocheSeguro = new CocheSeguro();
      if (this.storageService.ifExist("cocheSeguro")) {
        cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      }
      if (cocheSeguro.cia === 44 || cocheSeguro.cia === 3){
        this.requestServices.getRequestZurich({ projectName: new Configuration().URLINTER, apiName: 'catalogs/location/'+ this.contratante.direccion.cp, bearer: true })
        .subscribe(
          result => {
            if (result.error) {
              console.error('Error: ', result.error);
            } else {
              result.data.forEach(colonias => {
                this.contratante.direccion.ciudad = colonias.city_name;
                this.arrayColonia.push({c2: colonias.suburb_name, suburb_code: colonias.suburb_code, township_code: colonias.township_code, state_code: colonias.state_code});
              });
            }
          }, error => {
            console.error('Error: ', error);
          }
        );
      } else {
      this.requestServices.getRequest({ projectName: new Configuration().URLPOLIZAS, apiName: 'Sio4CodigoPostalAPI', params: dataPrimero })
        .subscribe(
          result => {
            if (result.error) {
              console.error('Error: ', result.error);
            } else {
              this.arrayColonia = result[0];
              this.arrayCiudad = result[1];
              let cocheSeguro: CocheSeguro = new CocheSeguro();
              if (this.storageService.ifExist("cocheSeguro")) {
                cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
              }
              if (cocheSeguro ?.contratante) {
                this.dateContratante = cocheSeguro ?.contratante;
                this.contratante.direccion.col = this.dateContratante.direccion.col;
              } else {
                this.contratante.direccion.col = result[0][0].c2;
              }
              this.contratante.direccion.ciudad = result[1][0].c2;
              this.contratante.direccion.munId = result[1][0].c3;
              this.contratante.direccion.estado = result[0][0]?.estado;
            }
          }, error => {
            console.error('Error: ', error);
          }
        );
      }
    }
  }

  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  next() {
    /**
     * Sacamos datos de ciudadID, municipioID, coloniaID cuando es AFIRME, para posteriornente ocupar los datos en la emisión
     */
     if(this.aseguradoraId == 31){
      const coloniaContranteLowerCase = this.contratante.direccion.col.toLowerCase();
      if(this.dataDireccion?.idCiudad){
        this.contratante.direccion.ciudadID = this.dataDireccion.idCiudad;
      }
      this.dataDireccion.municipios.forEach(municipio => {
        if(Array.isArray(municipio.colonias) && this.isArrayValidaLong(municipio.colonias,1)){
          const coloniaMatch = municipio.colonias.filter(colonia => 
                          this.quitarCaracteresEspeciales(coloniaContranteLowerCase).includes(
                            this.quitarCaracteresEspeciales(String(colonia.nombreColonia).toLowerCase())));
          
          if(this.contratante.direccion.municipioID == 0){
            this.contratante.direccion.municipioID = municipio.idMunicipio;
          }
          if(this.isArrayValidaLong(coloniaMatch,0) && this.contratante.direccion.coloniaID == 0){
            this.contratante.direccion.coloniaID = coloniaMatch[0].idColonia;
          }
        } else {
          if(this.contratante.direccion.municipioID == 0){
            this.contratante.direccion.municipioID = municipio.idMunicipio;
          }
          if(this.isArrayValidaLong(municipio.colonias,0) && this.contratante.direccion.coloniaID == 0){
            this.contratante.direccion.coloniaID = municipio.colonias[0].idColonia;
          }
        }
      });
    }
    if(this.aseguradoraId == 44 || this.aseguradoraId == 3){
      this.arrayColonia.forEach(colonias => {
        if (this.contratante.direccion.col === colonias.c2){
          this.contratante.direccion.municipioID = colonias.state_code;
          this.contratante.direccion.coloniaID = colonias.suburb_code;
          this.contratante.direccion.ciudadID = colonias.township_code;
        }
      });

    }

    this.fec_nac = this.contratante.fec_nac.split("/")[2] + '-' + this.contratante.fec_nac.split("/")[1] + '-' + this.contratante.fec_nac.split("/")[0];
    this.contratante.fec_nac_str = this.fec_nac;
    this.telefonos[0].num_tel = this.telefono;
    this.telefonos[1].num_tel = this.celular;
    this.contratante.telefonos = this.telefonos;
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }

    cocheSeguro.contratante = this.contratante;
    cocheSeguro.prospecto = this.dataProspecto;
    cocheSeguro.telefono = this.telefono;
    cocheSeguro.celular = this.celular;
    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
    this.updatelogConsumo();
    gtag({'event':'formStep2Submit'});
    if (this.const.PLATFORM) {
      window.location.href = this.const.URLPLATFORM + 'datos-emision-vehiculo';
    } else {
      this.router.navigate(['datos-emision-vehiculo']);
    }
  }
  
  isArrayValidaLong(array:any, long:number) {
    if(Array.isArray(array) && array.length > long){
      return true;
    }else{
      return false;
    }
  }

  back() {
    if (this.const.PLATFORM) {
      window.location.href = this.const.URLPLATFORM + 'cotizacion';
    } else {
      this.router.navigate(['cotizacion']);
    }
  }

  updatelogConsumo() {
    this.logConsumoFun.logConsumo();
  }

  updateJson() {
    this.fec_nac = this.contratante.fec_nac.split("/")[2] + '-' + this.contratante.fec_nac.split("/")[1] + '-' + this.contratante.fec_nac.split("/")[0];
    this.contratante.fec_nac_str = this.fec_nac;
    this.telefonos[0].num_tel = this.telefono;
    this.telefonos[1].num_tel = this.celular;
    this.contratante.telefonos = this.telefonos;
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }

    cocheSeguro.contratante = this.contratante;
    cocheSeguro.prospecto = this.dataProspecto;
    cocheSeguro.telefono = this.telefono;
    cocheSeguro.celular = this.celular;
    this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

    let parametro = (this.storageService.ifExist("ayuda")) ? 0 : 2;
    this.logConsumoFun.logConsumo(undefined, parametro);
    this.openModalMarcame();
    this.storageService.setItem("ayuda", JSON.stringify(true));
  }

  public fecNacimientoMask: any = {
    mask: [
      {
        mask: '00/00/0000',
        regex: '^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$'
      }
    ]
  };

  openModalMarcame() {
    let modalAyuda = this.modal.open(CotizacionAyudaComponent, { disableClose: false });
    modalAyuda.afterClosed().subscribe(result => {
    });
  }

  public telefonoMask: any = {
    mask: [
      {
        mask: '0000000000',
        regex: '^[0-9]{10}$'
      }
    ]
  };

  quitarCaracteresEspeciales(value): string {
    var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
        to   = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
        mapping = {};

    for(var i = 0; i < from.length; i++ ){
      mapping[ from.charAt(i) ] = to.charAt(i);
    }
    var ret = [];
    for( var i = 0; i < value.length; i++) {
        var c = value.charAt(i);
        if( mapping.hasOwnProperty( value.charAt(i)))
            ret.push( mapping[c] );
        else
            ret.push(c);
    }
    return ret.join('');
  }

  sexoEventListener(sexo) {

    let cocheSeguro: CocheSeguro = new CocheSeguro();

    if (this.storageService.ifExist("cocheSeguro")) {
      cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      if ((sexo == 'M') !== cocheSeguro.sexo) {
        this.avisoCambioCotizacion();
      }
    }
  }

  limiteLetras(event: KeyboardEvent) {

    this.keyPressBloqueaNumeros(event);
    this.keyPressBloqueaCaracteres(event);

  }

  avisoCambioCotizacion() {

    let simpleMess = this.modal.open(NotificacionComponent, { disableClose: true });

    simpleMess.componentInstance.default = true;
    simpleMess.componentInstance.accion = 'ACEPTAR';
    //simpleMess.componentInstance.title = 'ERROR EN COTIZACIÓN';
    simpleMess.componentInstance.message = 'Este cambio puede modificar tu cotización.';
    simpleMess.componentInstance.message = "<b class='font-marcameTxt'>Este cambio puede modificar tu cotización.</b>";

  }

  keyPressBloqueaNumeros(event: KeyboardEvent) {

    if (
      event?.key == '0' || event?.key == '1' ||
      event?.key == '2' || event?.key == '3' ||
      event?.key == '4' || event?.key == '5' ||
      event?.key == '6' || event?.key == '7' ||
      event?.key == '8' || event?.key == '9'
    ) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value = (<HTMLInputElement>event.target).value;
    }
  }

  keyPressBloqueaCaracteres(event: KeyboardEvent) {

    if(/[!'^+%&/"()=?¿_\-~`*¨;¡#$½ºª·Ç:.´¬€{[\]}\\|<>@,]/gi.test(event.key)) {
      event.preventDefault();
    } else {
      (<HTMLInputElement>event.target).value = (<HTMLInputElement>event.target).value;
    }
  }

  limitLetrasNumeros(event) {
    this.keyPressBloqueaCaracteres(event);
  }
}
